/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './core-mls.module';
export * from './translation';
export * from './message';
export * from './locale';
